export const getSiteOrigin = () => {
    if (typeof window !== "undefined" && window.location?.origin) {
        return window.location.origin;
    }

    return process.env.REACT_APP_HOST || "";
};

export const getSiteUrl = (path = "/") => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${getSiteOrigin()}${normalizedPath}`;
};

export const isShopSite = () => {
    if (typeof window === "undefined" || !window.location?.hostname) {
        return false;
    }

    return window.location.hostname === "shop.jerelia.com";
};

export const getProductPicturesBaseUrl = () => {
    return `${process.env.REACT_APP_CDN || ""}ProductPictures/v2/`;
};
